import { useState } from 'react';

export type ValidationState = {
  field: string;
  isValid: boolean;
};

export type UpdateValidationState = (s: ValidationState) => void;

const useValidationState = (): [UpdateValidationState, boolean] => {
  const [validationState, setValidationState] = useState<Record<string, boolean>>({});

  const updateValidationState: UpdateValidationState = (v) => {
    setValidationState((prev) => ({ ...prev, [v.field]: v.isValid }));
  };

  const validationStarted = Object.keys(validationState).length > 0;
  const allFieldsValid = Object.values(validationState).every((v) => v);
  const isValid = validationStarted && allFieldsValid;

  return [updateValidationState, isValid];
};

export default useValidationState;
